const destinations = [
  {
    name: "Japan & South Korea (Military)",
    context: "Misawa, Yokosuka, Okinawa, and Osan are common overseas assignments for NAS Pensacola-trained naval aviators. Navy pilots and their families receive PCS orders to these Pacific installations regularly",
    urgency: "PCS orders to Pacific installations often arrive with 30–45 days to report — dependent passports must be current",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Spain & Italy (Military)",
    context: "NAS Rota in Spain and NAS Sigonella in Italy are frequent Mediterranean assignments for Pensacola-trained personnel. European shore tours are popular and competitive assignments",
    urgency: "Mediterranean PCS assignments require current passports for spouses and children before official orders are cut",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Mexico & Cancun",
    context: "Cancun and Riviera Maya are the top spring break destinations for University of West Florida students and local families. PNS and Mobile Regional Airport offer connecting options; some travelers drive to Birmingham",
    urgency: "Spring break bookings peak in January — standard processing cannot accommodate March departure dates",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Caribbean & Bahamas",
    context: "Bahamas and Caribbean island-hopping attract Pensacola's boating and fishing community, who can reach Nassau and Key West via the Gulf and ICW routes. Cruise passengers depart from Port Canaveral and Mobile",
    urgency: "Boating trips to the Bahamas via the Intracoastal Waterway require valid passports for any Bahamian customs stop",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "United Kingdom",
    context: "RAF Lakenheath and RAF Mildenhall draw Pensacola-trained Navy and Air Force personnel to UK assignments. UK-based families visit back home in Pensacola and require current passports for return visits",
    urgency: "UK assignment orders often arrive with 30-day timelines — family passports must all be current before departure",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Bahrain & Middle East",
    context: "NSA Bahrain is a major assignment location for Pensacola-trained naval personnel. CENTCOM support roles draw NAS Pensacola-connected contractors and military professionals to the Persian Gulf region",
    urgency: "Middle East TDY and PCS orders can arrive with as little as 14 days notice for time-sensitive operational requirements",
    icon: "ri-map-pin-2-line",
  },
];

const stats = [
  { stat: "61%", label: "of Pensacola expedited requests involve military PCS orders, deployment prep, or overseas assignment timelines" },
  { stat: "30–45 Days", label: "typical NAS Pensacola PCS order notice window — not enough time for standard processing" },
  { stat: "7+ Hours", label: "round-trip driving time from Pensacola to the Atlanta Passport Agency — the nearest public option" },
  { stat: "48 Hours", label: "shortest military leave passport emergency we have accommodated for a Pensacola naval aviator" },
];

export default function PensacolaDestinationsSection() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Local Travel Intelligence</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Where Pensacola Travelers Go — And Why Passports Get Urgent
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Pensacola's passport demand is heavily military-driven — NAS Pensacola sends trained aviators to overseas assignments worldwide, creating a constant flow of families needing passports on compressed PCS timelines. Spring break and tourism round out the urgency profile.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-14">
          {stats.map((s, i) => (
            <div key={i} className="bg-[#1A365D] rounded-lg p-6 text-center">
              <p className="font-serif text-3xl font-bold text-[#F6C344] mb-2">{s.stat}</p>
              <p className="text-white/60 text-xs leading-relaxed">{s.label}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-12">
          {destinations.map((d, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200 hover:border-[#F6C344] transition-all group">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#1A365D]/5 group-hover:bg-[#F6C344]/15 transition-colors flex-shrink-0">
                  <i className={`${d.icon} text-[#1A365D] group-hover:text-[#F6C344] transition-colors text-lg`}></i>
                </div>
                <h3 className="font-bold text-[#1A365D] text-sm">{d.name}</h3>
              </div>
              <p className="text-gray-500 text-sm leading-relaxed mb-3">{d.context}</p>
              <div className="flex items-start gap-2">
                <i className="ri-time-line text-[#F6C344] text-xs flex-shrink-0 mt-0.5"></i>
                <p className="text-gray-400 text-xs leading-relaxed italic">{d.urgency}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#1A365D]/5 flex-shrink-0">
              <i className="ri-links-line text-[#1A365D] text-xl"></i>
            </div>
            <div className="flex-1">
              <h3 className="font-bold text-[#1A365D] text-sm mb-1">Explore Other Florida Service Areas</h3>
              <p className="text-gray-500 text-sm leading-relaxed">
                We serve travelers across the Florida Panhandle and all of Florida with the same expedited passport expertise.
              </p>
            </div>
            <div className="flex flex-wrap gap-2 flex-shrink-0">
              <a href="/panama-city" className="inline-flex items-center gap-1.5 bg-white hover:bg-[#1A365D] text-[#1A365D] hover:text-white border border-gray-200 hover:border-[#1A365D] font-medium text-xs px-3.5 py-2 rounded-md transition-all whitespace-nowrap">
                Panama City <i className="ri-arrow-right-line text-xs"></i>
              </a>
              <a href="/tallahassee" className="inline-flex items-center gap-1.5 bg-white hover:bg-[#1A365D] text-[#1A365D] hover:text-white border border-gray-200 hover:border-[#1A365D] font-medium text-xs px-3.5 py-2 rounded-md transition-all whitespace-nowrap">
                Tallahassee <i className="ri-arrow-right-line text-xs"></i>
              </a>
              <a href="/jacksonville" className="inline-flex items-center gap-1.5 bg-white hover:bg-[#1A365D] text-[#1A365D] hover:text-white border border-gray-200 hover:border-[#1A365D] font-medium text-xs px-3.5 py-2 rounded-md transition-all whitespace-nowrap">
                Jacksonville <i className="ri-arrow-right-line text-xs"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}